import type { Product } from '@bucketplace/common';
import { type QueryFunctionContext, skipToken } from '@tanstack/react-query';
import type { KyHeadersInit } from 'ky/distribution/types/options';
import { z } from 'zod';
import { getStoreItemsInputSchema } from '../get-store-items/get-store-items';

export const getPersonalizedStoreItemsInputSchema = getStoreItemsInputSchema
  .omit({ ids: true })
  .extend({
    userId: z.union([z.number(), z.string()]),
  });

export const getPersonalizedStoreItemsResponseSchema = z.object({
  items: z.array(z.custom<Product>()),
});

export type GetPersonalizedStoreItemsInput = z.infer<
  typeof getPersonalizedStoreItemsInputSchema
>;
export type GetPersonalizedStoreItemsResponse = z.infer<
  typeof getPersonalizedStoreItemsResponseSchema
>;
export type GetPersonalizedStoreItemsApi = (params: {
  input: GetPersonalizedStoreItemsInput;
  headers?: KyHeadersInit;
  signal?: AbortSignal;
}) => Promise<GetPersonalizedStoreItemsResponse>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createGetPersonalizedStoreItemsQueryOptions = ({
  api,
  input,
  skip,
}: {
  api: GetPersonalizedStoreItemsApi;
  input: GetPersonalizedStoreItemsInput;
  skip?: boolean;
}) => {
  return {
    queryKey: ['getPersonalizedStoreItems', input],
    queryFn: skip
      ? skipToken
      : ({ signal }: QueryFunctionContext) => api({ input, signal }),
  } as const;
};
